import { gql } from '@apollo/client'

export default gql(`
  query getAccessRoleGroups($project: String){
    getAccessRoleGroups(project: $project){
      id
      name
      description
      createdAt
      ip
      masterFlag
      modules{
        name
        permissions
      }
      users{
        id
        accessRoleGroups {
          id
        }
      }
    }
  }`
)
